import React from 'react';
import classNames from 'classnames';

interface Props {
  className?: string;
}

const Loading: React.FC<Props> = (props) => {
  return (
    <div className={classNames('spinner black', { [props.className]: props.className })}>
      <div className="bounce1"></div>
      <div className="bounce2"></div>
      <div className="bounce3"></div>
    </div>
  );
};

export default Loading;
